module.exports = __webpack_public_path__ + "static/media/gateway5.2c93ef8d.jpg";